import React from 'react';
import TutorialCard from './TutorialCard';

/**
 * TutorialOverlay renders the tutorial card and overlay
 * Prevents user interaction with the app during tutorial
 * 
 * @param {boolean} active - Whether the tutorial is active
 * @param {string} text - Current tutorial text to display
 * @param {number} currentStep - Current step number
 * @param {number} totalSteps - Total number of steps
 * @param {function} onNext - Function to call when the next button is clicked
 * @param {function} onSkip - Function to call when the skip button is clicked
 * @param {function} onPrevious - Function to call when the previous button is clicked
 */
const TutorialOverlay = ({ 
  active = false,
  text = '',
  currentStep = 1, 
  totalSteps = 1,
  onNext = () => {},
  onSkip = () => {},
  onPrevious = () => {}
}) => {
  // Safety check - don't render if not active
  if (!active) return null;
  
  // Additional safety check for required props
  if (currentStep < 1 || !text) {
    console.warn('TutorialOverlay: Missing required props', { active, text, currentStep });
    return null;
  }
  
  return (
    <>
      {/* Prevents interaction with app elements */}
      <div className="tutorial-overlay" />
      
      {/* Tutorial instruction card */}
      <TutorialCard 
        text={text}
        currentStep={currentStep}
        totalSteps={totalSteps}
        onNext={onNext}
        onSkip={onSkip}
        onPrevious={onPrevious}
      />
    </>
  );
};

export default TutorialOverlay; 